export function triggerVideoly () {
	(function (d, e, n) {
		e = d.createElement('script');
		e.type = 'text/javascript';
		e.async = true;
		e.src = 'https://api.videoly.co/1/quchbox/0/5284/quch.js';
		n = d.getElementsByTagName('script')[0];
		n.parentNode.insertBefore(e, n);
	})(document);
};